export const AUTHENTICATION_PROFILE_LIST_TAG_NAME = 'authentication-profile-list-container';
export const AUTHENTICATION_PROFILE_DETAIL_TAG_NAME = 'authentication-profile-detail-container';
